import React, { useContext, useEffect, useState } from 'react'
import {
  AppointmentModel,
  EquipamentsModel,
  SurgicalScheduleModel
} from 'domain/entities/surgical-schedule-model'
import Divider from 'presentation/shared/components/DividerNew'
// import Heading from 'presentation/shared/components/Heading'
import { useHistory } from 'react-router'
import * as S from './styles'
import moment from 'moment'
import { Procedure } from 'presentation/doctor/pages/Patient'
import { ReactComponent as CirclePlusIcon } from 'presentation/assets/icons/circle-plus.svg'
import { ReactComponent as CloseIcon } from 'presentation/assets/icons/close.svg'
// import { ReactComponent as CalendarIcon } from 'presentation/assets/icons/calendar-icon.svg'
import Modal from 'presentation/shared/components/Modal'
import { ReactComponent as TrashIcon } from 'presentation/assets/icons/trash-icon.svg'
import { ReactComponent as InfoCircle } from 'presentation/assets/icons/info-circle.svg'
import RadioButtonNew from 'presentation/shared/components/RadioButtonNew'
import CardNew from 'presentation/shared/components/CardNew'
import AutoCompleteNew from 'presentation/shared/components/AutoCompleteNew'
import { useServices } from 'presentation/hooks/use-services'
import { toast } from 'react-toastify'
import SelectFieldNew from 'presentation/shared/components/SelectFieldNew'
import ButtonNew from 'presentation/shared/components/ButtonNew'
import { ReactComponent as SearchIcon } from 'presentation/assets/icons/search.svg'
import { ReactComponent as ManCalendar } from 'presentation/assets/scheduling-sector/man-calendar.svg'
import LoadingModal from 'presentation/shared/components/LoadingModal'
import { useFormik } from 'formik'
import {
  ModalDetails,
  optionsTime,
  PropsEquipamentsModel,
  ScheduleRequest
} from '../types'
import CalendarNew from 'presentation/shared/components/CalendarNew'
import { getAnesthetistType, getMainProcedureName } from '../functions'
import { SurgicalSchedulingContext, SurgicalSchedulingState } from '../context'
import { TooltipNew } from 'presentation/shared/components/TooltipNew'
import CalendarTests from 'presentation/hospital/pages/Home/SchedulingSector/CalendarTests'
import { TimeStatus } from 'common/enum/time-status'
import AccordionNew from 'presentation/shared/components/AccordionNew'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'

export const SolicitationCreateSurgicalScheduleLayout = () => {
  const surgicalScheduleService = useServices().surgicalSchedule
  const history = useHistory() as any
  const scheduleRequest = history.location.state.item as SurgicalScheduleModel
  const [surgicalCenters, setSurgicalCenters] = useState() as any
  const [selectedSurgeryCenter, setSelectedSurgeryCenter] = useState('') as any
  const [isLoading, setIsLoading] = useState(false)

  const { dispatch, state } = useContext<any>(
    SurgicalSchedulingContext
  ) as SurgicalScheduleModelContext

  type SurgicalScheduleModelContext = {
    dispatch: any
    state: SurgicalSchedulingState
  }

  function changeSurgeryCenter(value: any) {
    if (state.surgical_center_schedule) {
      dispatch({
        type: 'SURGICAL_CENTER_SCHEDULE',
        payload: null
      })
    }

    if (value !== 'null') {
      setSelectedSurgeryCenter(value)
    } else {
      setSelectedSurgeryCenter('')
    }

    const roomName = surgicalCenters.filter((room: any) => {
      return room.value === value
    })[0].label

    dispatch({
      type: 'SURGICAL_CENTER',
      payload: {
        room_id: value,
        surgery_center_name: roomName
      }
    })
  }

  async function getSurgicalCenters() {
    try {
      setIsLoading(true)
      const response = await surgicalScheduleService.loadHospitalSurgeryCenter({
        hospital_id: scheduleRequest.surgical_order.hospital_id
      })

      const roomOptions = response.data.map((surgicalCenter) => {
        return { label: surgicalCenter.name, value: surgicalCenter.code }
      })

      setSurgicalCenters(roomOptions)
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      toast.error('Falha ao buscar informações da solicitação')
    }
  }

  useEffect(() => {
    getSurgicalCenters()
    if (scheduleRequest.surgical_order.surgery_center_name) {
      setSelectedSurgeryCenter(scheduleRequest.surgical_order.room_id)
    }
  }, [])

  const captions = [
    {
      color: 'green',
      label: 'Cirurgia agendada'
    },
    {
      color: 'purple',
      label: 'Preparação da sala'
    },
    {
      color: 'gray',
      label: 'Solicitação de agendamento'
    },
    {
      color: 'orange',
      label: 'Sala fechada/interditada'
    },
    {
      color: 'blue',
      label: 'Reserva de sala'
    }
  ]

  return (
    <>
      <S.Wrapper>
        <SideContainer
          scheduleRequest={scheduleRequest}
          surgicalCenters={surgicalCenters}
          changeSurgeryCenter={changeSurgeryCenter}
          selectedSurgeryCenter={selectedSurgeryCenter}
          dispatch={dispatch}
          state={state}
        />

        <S.InformationsContainer>
          <AccordionNew
            padding="8px"
            defaultExpanded={true}
            display="block"
            items={[
              {
                title: `Aviso Cirúrgico ${scheduleRequest?.surgical_order.id}`,
                content: (
                  <S.FlexContainer>
                    <PatientInfo scheduleRequest={scheduleRequest} />
                    <S.Separator />
                    <SurgeryInfo
                      dispatch={dispatch}
                      scheduleRequest={scheduleRequest}
                    />
                  </S.FlexContainer>
                )
              }
            ]}
          />

          {state.surgical_center_schedule ? (
            <>
              <CardNew shadow="none" padding="24px">
                <CalendarTests
                  searchDate={state.surgical_center_schedule.day}
                  numberOfRooms={state.surgical_center_schedule.rooms.length}
                  schedules={state.schedules}
                  surgeryCenterName={state.surgical_order.surgery_center_name}
                  requestedTime={state.time.requested_time}
                  state={state}
                />
              </CardNew>
              <CardNew
                shadow="none"
                style={{
                  flexDirection: 'row'
                }}
              >
                {captions.map((caption) => {
                  return (
                    <S.Caption key={caption.label}>
                      <S.Ball color={caption.color} />
                      <span>{caption.label}</span>
                    </S.Caption>
                  )
                })}
                <S.Caption>
                  <S.SelectedRequestBall />
                  <span>Solicitação selecionada</span>
                </S.Caption>
              </CardNew>
            </>
          ) : (
            <S.EmptyState shadow="none">
              <SupportTextNew weight="bold" size="large">
                Preencha as informações à esquerda para visualizar o calendário
              </SupportTextNew>
              <ManCalendar />
            </S.EmptyState>
          )}
        </S.InformationsContainer>
      </S.Wrapper>
      <LoadingModal show={isLoading} />
    </>
  )
}

const SideContainer = ({
  scheduleRequest,
  selectedSurgeryCenter,
  changeSurgeryCenter,
  surgicalCenters,
  dispatch,
  state
}: any) => {
  const [calendarVisible, setCalendarVisible] = useState(false) as any
  const [isLoading, setIsLoading] = useState(false)
  const [selectedDuration, setSelectedDuration] = useState(false)
  const [availableDays, setAvailableDays] = useState([]) as any
  const surgicalScheduleService = useServices().surgicalSchedule
  const [activeDate, setActiveDate] = useState() as any
  function changeTime(requested_time: any) {
    if (requested_time !== 'null') {
      setSelectedDuration(true)
    } else {
      setSelectedDuration(false)
    }
    if (state.surgical_center_schedule) {
      dispatch({
        type: 'SURGICAL_CENTER_SCHEDULE',
        payload: null
      })
    }

    dispatch({ type: 'TIME', payload: { requested_time } })
  }

  function getMainAppointment() {
    const mainAppointment = scheduleRequest?.appointments?.filter(
      (appointment: AppointmentModel) => {
        return appointment?.justificative
      }
    )

    return mainAppointment as any
  }

  useEffect(() => {
    if (calendarVisible) {
      getSurgicalScheduleAvailability()
    }
  }, [
    state?.time?.requested_time,
    state?.surgical_order?.room_id,
    calendarVisible
  ])

  async function getSurgicalScheduleAvailability(activeStartDate?: any) {
    if (activeStartDate) {
      setActiveDate(activeStartDate)
    }

    const currentSelectedDate = activeStartDate || activeDate

    try {
      setIsLoading(true)
      const response =
        await surgicalScheduleService.loadSurgicalScheduleAvailableDays({
          startDate: moment(currentSelectedDate).format('YYYY-MM-DD'),
          endDate: moment(currentSelectedDate)
            .endOf('month')
            .format('YYYY-MM-DD'),
          duration: state.time.requested_time,
          surgeryCenterCode: state.surgical_order.room_id
        })

      const formatedAvailableDays = response.data.map((item: any) => {
        return +moment(item.day).format('DD')
      })

      setAvailableDays(formatedAvailableDays)
      setIsLoading(false)
    } catch (error) {
      toast.error('Falha ao buscar disponibilidade')
      setIsLoading(false)
    } finally {
      setIsLoading(false)
    }
  }

  const isDisabledDate = ({ date, view }: any) => {
    if (view === 'month') {
      return !availableDays?.includes(+moment(date).format('DD'))
    }
    return false
  }

  function openCalendar() {
    dispatch({ type: 'SELECTED_DATE', payload: '' })
    setCalendarVisible(true)
    getSurgicalScheduleAvailability(new Date())
  }

  function selectRequestedDate(value: any, suggested?: boolean) {
    const formatedDate = moment(value).format('YYYY-MM-DD')
    dispatch({ type: 'SELECTED_DATE', payload: formatedDate })

    getSurgicalScheduleAvailability()

    if (suggested) {
      setCalendarVisible(false)
    }
  }

  async function getSurgicalCenterCalendar(
    selectedDate: string,
    surgery_center_id: number
  ) {
    try {
      setIsLoading(true)
      const response = await surgicalScheduleService.loadSurgeryCenterCalendar({
        code: surgery_center_id,
        date: selectedDate
      })

      dispatch({ type: 'SURGICAL_CENTER_SCHEDULE', payload: response.data })

      const formatedSchedules = [] as any
      response.data.rooms.forEach((room, index) => {
        room.schedules.forEach((schedule) => {
          formatedSchedules.push({
            title:
              schedule.type === TimeStatus.PREPARATION
                ? 'Preparação'
                : schedule.description,
            date: moment.utc(response.data.day).format('YYYY-MM-DD'),
            start: moment
              .utc(schedule.start)
              .add(index + 1 - 1, 'days')
              .format('YYYY-MM-DD HH:mm'),
            end: moment
              .utc(schedule.end)
              .add(index + 1 - 1, 'days')
              .format('YYYY-MM-DD HH:mm'),

            extendedProps: {
              subtitle: '',
              timeStatus: schedule.type,
              schedule_id: schedule.schedule_id,
              preparation_time: room.preparation_time,
              selectedRoomId: room.room_id,
              selectedRoomName: room.name,
              surgical_order_id: schedule.surgical_order_id
            }
          })
        })
      })

      dispatch({
        type: 'CALENDAR_SCHEDULE',
        payload: formatedSchedules
      })

      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      toast.error('Falha ao buscar informações do centro cirúrgico')
    }
  }

  function searchAvailability() {
    getSurgicalCenterCalendar(state.selectedDate, state.surgical_order.room_id)
  }

  useEffect(() => {
    if (state.toggleRefreshCalendar) {
      searchAvailability()
    }
  }, [state.toggleRefreshCalendar])

  const formattedDate = (date: Date) => {
    return moment.utc(date).format('DD/MM/YYYY [às] HH:mm')
  }

  return (
    <S.FiltersContainer shadow="none" gap="24px">
      <SupportTextNew color="neutral900" weight="semiBold" size="medium">
        Insira as informações abaixo para visualizar a disponibilidade das salas
        e horários:
      </SupportTextNew>

      <div>
        <SelectFieldNew
          label="Unidade Cirúrgica"
          required={true}
          value={selectedSurgeryCenter}
          items={surgicalCenters}
          onInputChange={(value) => changeSurgeryCenter(+value)}
        />
        <SupportTextNew style={{ marginTop: '8px' }}>
          <SupportTextNew as="span" weight="semiBold">
            Sugerida pelo médico:{' '}
          </SupportTextNew>
          {scheduleRequest?.surgical_order?.surgery_center_name}
        </SupportTextNew>
      </div>

      <div>
        <SelectFieldNew
          label="Duração da cirurgia"
          required={true}
          // value={state?.time?.requested_time || state?.time?.predicted_time}
          items={optionsTime}
          onInputChange={(value) => {
            changeTime(value)
          }}
        />

        <div
          style={{
            gap: '8px',
            display: 'flex',
            flexDirection: 'column',
            marginTop: '8px'
          }}
        >
          <SupportTextNew
            weight="semiBold"
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <TooltipNew text="Tempo médio calculado pelo sistema.">
              <InfoCircle style={{ marginRight: '8px' }} />
            </TooltipNew>
            Tempo estimado de cirurgia:&nbsp;
            <SupportTextNew as="span" weight="normal">
              {scheduleRequest?.time.predicted_time}
            </SupportTextNew>
          </SupportTextNew>

          {scheduleRequest?.time.requested_time && (
            <SupportTextNew
              weight="semiBold"
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <TooltipNew text="O tempo sugerido pelo solicitante é diferente do calculado pelo sistema.">
                <InfoCircle style={{ marginRight: '8px' }} />
              </TooltipNew>
              Tempo sugerido pelo médico:&nbsp;
              <SupportTextNew as="span" weight="normal">
                {scheduleRequest?.time.requested_time}
              </SupportTextNew>
            </SupportTextNew>
          )}

          {scheduleRequest?.time.justificative && (
            <div>
              <SupportTextNew weight="semiBold">
                Justificativa de alteração do médico:
              </SupportTextNew>
              <SupportTextNew>
                {scheduleRequest?.time.justificative}
              </SupportTextNew>
            </div>
          )}
        </div>
      </div>

      <S.SelectDateContainer>
        <SupportTextNew color="neutral900" weight="semiBold" size="medium">
          Escolha uma das datas solicitadas
        </SupportTextNew>
        <div>
          {scheduleRequest?.appointments?.map(
            (appointment: AppointmentModel, index: number) => {
              return (
                <S.RadioContainer key={index}>
                  <RadioButtonNew
                    showBackground={false}
                    name="type"
                    labelFor="initial"
                    value={String(appointment.start_date)}
                    label={formattedDate(appointment.start_date)}
                    onCheck={(value) => selectRequestedDate(value, true)}
                    disabled={
                      !state.time?.requested_time ||
                      !state.surgical_order?.room_id ||
                      moment(appointment.start_date).isBefore(new Date())
                    }
                  />
                  {appointment.is_preferential &&
                    moment(appointment.start_date).isAfter(new Date()) && (
                      <SupportTextNew size="xsmall">
                        &nbsp;(Preferencial)
                      </SupportTextNew>
                    )}
                  {moment(appointment.start_date).isBefore(new Date()) && (
                    <SupportTextNew size="xsmall">
                      &nbsp;(Indisponível)
                    </SupportTextNew>
                  )}
                </S.RadioContainer>
              )
            }
          )}

          {/* {state.time?.requested_time && ( */}
          <S.RadioContainer>
            <RadioButtonNew
              showBackground={false}
              name="type"
              labelFor="initial"
              label="Escolher outra data"
              onCheck={openCalendar}
              disabled={!selectedDuration || !selectedSurgeryCenter}
            />
          </S.RadioContainer>
          <SupportTextNew as="span" weight="light" size="xxsmall">
            Selecione a duração e o tipo de sala para escolher uma data:{' '}
          </SupportTextNew>
          {/* )} */}
        </div>

        {getMainAppointment()[0]?.justificative && (
          <div>
            <SupportTextNew weight="semiBold">
              Motivo da data/horário de preferência:
            </SupportTextNew>
            <SupportTextNew className="gray-span">
              {getMainAppointment()[0]?.justificative}
            </SupportTextNew>
          </div>
        )}
      </S.SelectDateContainer>

      {calendarVisible && selectedSurgeryCenter && selectedDuration && (
        <>
          <div className="calendar">
            <CalendarNew
              minDate={new Date()}
              onActiveStartDateChange={({ activeStartDate }: any) =>
                getSurgicalScheduleAvailability(activeStartDate)
              }
              tileDisabled={isDisabledDate}
              onClickDay={(value) => selectRequestedDate(value)}
            />
          </div>
        </>
      )}

      <ButtonNew
        onClick={() => searchAvailability()}
        fullWidth
        style={{ marginTop: '20px' }}
        disabled={
          !availableDays.length || !selectedDuration || !selectedSurgeryCenter
        }
      >
        Buscar disponibilidade
      </ButtonNew>
      <LoadingModal show={isLoading} />
    </S.FiltersContainer>
  )
}

const PatientInfo = ({ scheduleRequest }: ScheduleRequest) => {
  return (
    <S.ContainerInfo>
      <strong>Dados do paciente:</strong>
      <h1 className="patient-name">{scheduleRequest.patient.name}</h1>
      <p className="patient-info">
        Data de Nascimento: &nbsp;
        <span>
          {moment.utc(scheduleRequest.patient.birthday).format('DD/MM/YYYY')}
        </span>
      </p>
      <p className="patient-info">
        Convênio:&nbsp;
        <span>{scheduleRequest.surgical_order.health_insurance.name}</span>
      </p>
    </S.ContainerInfo>
  )
}

export type Props = {
  scheduleRequest: SurgicalScheduleModel
  dispatch: (action: { type: any; payload: any }) => void
}

const SurgeryInfo = ({ scheduleRequest, dispatch }: Props) => {
  const [showModalDetails, setShowModalDetails] = useState<boolean>(false)
  const [showModalEquipments, setShowModalEquipments] = useState<boolean>(false)
  const surgicalScheduleService = useServices().surgicalSchedule
  const [schedule, setSchedule] = useState({}) as any
  const [isLoading, setIsLoading] = useState(false)

  async function getSchedule() {
    try {
      setIsLoading(true)
      const response = await surgicalScheduleService.loadSurgicalSchedule({
        scheduling_id: scheduleRequest.id
        // surgical_order_id?: number
        // scheduling_id?: number
      })
      setSchedule(response.data)

      dispatch({
        type: 'START',
        payload: response.data
      })

      setIsLoading(false)
    } catch (error) {
      toast.error('Falha ao buscar informações da solicitação')
      setIsLoading(false)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getSchedule()
  }, [])

  return (
    <>
      <S.ContainerInfo>
        <strong>Informações da cirurgia:</strong>
        <h1>
          {getMainProcedureName(scheduleRequest.surgical_order.procedures)}
          &nbsp; <CirclePlusIcon onClick={() => setShowModalDetails(true)} />
        </h1>

        <S.GridInfo>
          <div>
            <p>Cirurgião responsável: &nbsp;</p>
            <span>{scheduleRequest.doctor.name}</span>
            <p>
              {getAnesthetistType(scheduleRequest.anesthetist)?.title} &nbsp;
            </p>
            <span>{getAnesthetistType(scheduleRequest.anesthetist)?.data}</span>
          </div>

          <div>
            <p>
              Especialidade: &nbsp;
              <span>{schedule.doctor?.specialty}</span>
            </p>
            <p>
              Congelação: &nbsp;
              <span>
                {scheduleRequest.surgical_order.freezing ? 'Sim' : 'Não'}
              </span>
            </p>
            <p>
              Técnica: &nbsp;
              <span>{scheduleRequest.surgical_order.tecnic}</span>
            </p>
          </div>

          <div>
            <p>
              Precisa de banco de Sangue?: &nbsp;
              <span>
                {scheduleRequest.surgical_order.blood_reserve ? 'Sim' : 'Não'}
              </span>
            </p>
            <p>
              Precisa de CTI? &nbsp;
              <span>{scheduleRequest.surgical_order.cti ? 'Sim' : 'Não'}</span>
            </p>
            <p>
              Precisa incluir equipamentos? &nbsp;
              <span>{scheduleRequest.equipaments.length ? 'Sim' : 'Não'}</span>
            </p>
            <a onClick={() => setShowModalEquipments(true)}>Ver equipamentos</a>
          </div>
        </S.GridInfo>
      </S.ContainerInfo>
      <ModalDetailsSchedule
        scheduleRequest={scheduleRequest}
        showModalDetails={showModalDetails}
        setShowModalDetails={setShowModalDetails}
      />
      <ModalEquipaments
        scheduleRequest={scheduleRequest}
        showModalEquipments={showModalEquipments}
        setShowModalEquipments={setShowModalEquipments}
      />
      <LoadingModal show={isLoading} />
    </>
  )
}

const ModalDetailsSchedule = ({
  scheduleRequest,
  showModalDetails,
  setShowModalDetails
}: ModalDetails) => {
  return (
    <Modal
      style={{ display: 'block', width: '45%', padding: 20 }}
      show={showModalDetails}
      close={() => setShowModalDetails(false)}
      preventAutomateClose
    >
      <S.ModalInfo>
        <S.Title>Mais detalhes</S.Title>
        <CloseIcon onClick={() => setShowModalDetails(false)} />
      </S.ModalInfo>
      <Divider />
      <S.ScrollContainer>
        <S.Subtitle>
          Procedimentos cirúrgicos
          {scheduleRequest.surgical_order.procedures.map(
            (procedure: Procedure) => {
              return (
                <li key={procedure.procedure_code}>{procedure.description}</li>
              )
            }
          )}
        </S.Subtitle>

        <S.Subtitle>
          Observações gerais
          <p>{scheduleRequest.general_observation}</p>
        </S.Subtitle>
      </S.ScrollContainer>
    </Modal>
  )
}

const ModalEquipaments = ({
  showModalEquipments,
  setShowModalEquipments
}: PropsEquipamentsModel) => {
  return (
    <Modal
      style={{ display: 'block', width: '480px', padding: 20 }}
      show={showModalEquipments}
      close={() => setShowModalEquipments(false)}
      preventAutomateClose
    >
      <S.ModalInfo>
        <S.Title>Equipamentos</S.Title>
        <CloseIcon onClick={() => setShowModalEquipments(false)} />
      </S.ModalInfo>
      <Divider />
      <EquipmentsCard setShowModalEquipments={setShowModalEquipments} />
    </Modal>
  )
}

const EquipmentsCard = ({ setShowModalEquipments }: any) => {
  const surgicalScheduleService = useServices().surgicalSchedule
  const [suggestions, setSuggestions] = useState([])
  const [searchTerm, setSearchTerm] = useState() as any
  const [selectedItem, setSelectedItem] = useState() as any
  const { dispatch, state } = useContext<any>(SurgicalSchedulingContext)

  const { errors, handleSubmit, setFieldValue } = useFormik({
    initialValues: { equipamentName: '' },
    // validationSchema,
    onSubmit: () => {
      addEquipament()
    }
  })

  async function searchEquipament(equipment: string) {
    try {
      const response = (await surgicalScheduleService.loadEquipaments({
        name: equipment
      })) as EquipamentsModel[]

      const mappedSuggestions = response.map((item: EquipamentsModel) => {
        return {
          label: item.name,
          value: item.code,
          isSolicitation: item.isSolicitation
        }
      }) as []
      setSuggestions(mappedSuggestions)
    } catch (error: any) {
      toast.error(error?.message)
    }
  }

  const addEquipament = () => {
    if (!selectedItem && !searchTerm) {
      toast.error('Selecione um equipamento')
      return
    }

    if (selectedItem) {
      const newList = state.equipaments.concat({
        code: selectedItem.value,
        name: selectedItem.label,
        isSolicitation: selectedItem.isSolicitation
      })

      setSelectedItem(null)
      setSearchTerm('')
      dispatch({
        type: 'EQUIPAMENTS',
        payload: newList
      })

      toast.success('Equipamento adicionado com sucesso.')
    }

    if (!selectedItem && searchTerm) {
      const newList = state.equipaments.concat({
        name: searchTerm
      })

      setSelectedItem(null)
      setSearchTerm('')
      dispatch({
        type: 'EQUIPAMENTS',
        payload: newList
      })
      toast.success('Equipamento adicionado com sucesso.')
    }
  }

  const selectItem = (item: { value?: number; label: string }) => {
    const filteredItem = suggestions.filter((suggestion: any) => {
      return suggestion.value === item
    }) as any

    setSelectedItem(filteredItem[0])
    setSearchTerm(filteredItem[0].label)
  }

  function setInputItem(item: any) {
    setFieldValue('equipamentName', item)
    selectItem(item)
  }

  const removeEquipament = (index: number) => {
    const newList = [...state.equipaments]
    newList.splice(index, 1)

    dispatch({
      type: 'EQUIPAMENTS',
      payload: newList
    })
  }

  return (
    <>
      {state.equipaments.length > 0 ? (
        <>
          <S.TableHeader>
            <tr className="header">
              <th>Código</th>
              <th>Equipamento</th>
              <th></th>
            </tr>
          </S.TableHeader>

          <S.ScrollTableContainer>
            <S.Table>
              {state.equipaments.map(
                (equipment: EquipamentsModel, index: number) => {
                  return (
                    <tr key={equipment.code}>
                      <td className="code">{equipment.code || 'Sem código'}</td>
                      <td className="description">{equipment.name}</td>
                      <td className="trash">
                        <TrashIcon onClick={() => removeEquipament(index)} />{' '}
                      </td>
                    </tr>
                  )
                }
              )}
            </S.Table>
          </S.ScrollTableContainer>
        </>
      ) : (
        <S.SoftText>Nenhum equipamento foi adicionado</S.SoftText>
      )}

      <AutoCompleteNew
        label="Adicionar equipamento"
        labelColor="neutral900"
        labelWeight="semiBold"
        placeholder="Pesquisar equipamento"
        name="equipamentName"
        value={searchTerm}
        icon={<SearchIcon />}
        iconPosition="insideLeft"
        iconColor="neutral900"
        onType={searchEquipament}
        onInputChange={setSearchTerm}
        suggestions={suggestions}
        onSuggestionClick={(item: any) => setInputItem(item)}
        clear={() => setSearchTerm('')}
        // required
        minCharactersSearch={2}
        debounceDelay={1000}
        error={errors.equipamentName}
      />

      <S.ButtonPanel>
        <ButtonNew variant="text" onClick={() => setShowModalEquipments(false)}>
          Concluir
        </ButtonNew>
        <ButtonNew onClick={() => handleSubmit()}>Adicionar</ButtonNew>
      </S.ButtonPanel>
    </>
  )
}
